import React,{useState,useEffect} from "react";
import { useTranslate } from 'react-redux-multilingual'
import {FormatedPrice} from '@gull'
import axios from 'axios'
import swal from "sweetalert2";

const ModalChequeDetail = (props) =>{
    const t =useTranslate()
    const [paymentRecords,setPaymentRecords]=useState([])
    
    const [loading,setLoading]=useState({
        data:false,
    })

    let url = "api/pos/ticket/get_check_infos/"+props.showCheque

    // On récupère le paiement record du cheque
    useEffect(function () {
        (async function() {
            setLoading({...loading,data:true})
            const response = await axios.get(process.env.REACT_APP_API_URL+url
            ).then((response) => {
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach(interm=>messageError+=t(interm)+'. ')
                    messageError=messageError.replace('undefined','');
                    swal.fire(messageError, "", "error");
                }
                else{   
                    setPaymentRecords(response.data.data)
                    setLoading({...loading,data:false})
                }
            }).catch((error) => {
                if(error=='end_session') return;
                let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                swal.fire(t(errorName), "", "error");
            })
            setLoading({...loading,data:false})
        })()
    }, [])

    if(loading.data){
        return(
            <span className="d-flex justify-content-center"><div className="spinner-border spinner-border-sm"></div></span>
        )
    }else{
        return(
            <div className="row">
                <div className="col">
                    <div className="row input-group">
                        <div className="col mb-2">
                            <label htmlFor="modepaiement">{t('labelBank')}:</label>
                            <span>{' '+paymentRecords?.check_infos?.tireur}</span>
                        </div>
                    </div>
                    <div className="row input-group mb-2">
                        <div className="col">
                            <label htmlFor="checknumber">{t('checkNumber')}:</label>
                            <span>{' '+paymentRecords?.check_infos?.nbr}</span>
                        </div>
                    </div>
                    <div className="row input-group mb-2">
                        <div className="col">
                            <label htmlFor="nomdutireur">{t('drawerName')}:</label>
                            <span>{' '+paymentRecords?.check_infos?.banque}</span>
                        </div>
                    </div>
                    <div className="row input-group mb-2">
                        <div className="col">
                            <label htmlFor="nomdutireur">{t('amount')}:</label>
                            <span>{' '}<FormatedPrice langRegion={'fr-FR'} devise={props.devise} digit={props.digit} priceToFormat={(paymentRecords?.montant) ? paymentRecords?.montant : 0} /></span>
                        </div>
                    </div>
                </div>
            </div>
        )    
    }
}

export default ModalChequeDetail;